import { useParams, Navigate } from "react-router-dom";
import { Seo } from "@/components/Seo";
import { PageHero } from "@/components/PageHero";
import { ServiceCard } from "@/components/ServiceCard";
import { getCategory, servicesByCategory } from "@/data/site";

export default function CategoryPage() {
  const { categorySlug } = useParams();
  const category = getCategory(categorySlug);
  if (!category) return <Navigate to="/services" replace />;
  const services = servicesByCategory(categorySlug);

  return (
    <>
      <Seo
        title={`${category.name} in Manikonda, Hyderabad | Ody Luxurious Spa`}
        description={`${category.name} at Ody Luxurious Spa Manikonda — ${category.tagline}. Certified therapists, private suites. Call or WhatsApp +91 90147 29756 to book.`}
        keywords={`${category.name} Manikonda, ${category.name} Hyderabad, spa Manikonda, Ody Luxurious Spa`}
      />
      <PageHero
        eyebrow={category.eyebrow}
        title={category.name}
        subtitle={category.description}
        crumbs={[{ label: "Services", to: "/services" }, { label: category.name }]}
        image={category.image}
      />
      <section className="py-20 sm:py-28">
        <div className="max-w-7xl mx-auto px-5 sm:px-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {services.map((s, i) => (
              <ServiceCard key={s.slug} service={s} index={i} />
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
